module.exports = __webpack_public_path__ + "img/rae-logo.13cfde90.png";